import OutboundLink from "./OutboundLink";
import archidekt from "../assets/ads/archidekt.png";
import csb from "../assets/ads/csb.png";
import fabrec from "../assets/ads/fabrec.png";
import styles from "../styles/Ad.module.scss";

const config = {
  archidekt: { alt: "Archidekt", src: archidekt, url: "archidekt.com" },
  csb: { alt: "Commander Spellbook", src: csb, url: "commanderspellbook.com" },
  fabrec: { alt: "FABREC", src: fabrec, url: "fabrec.gg" },
};

const Ad = ({ id }) => {
  if (!Object.keys(config).includes(id)) {
    return null;
  }

  const { alt, src, url } = config[id];

  return (
    <OutboundLink url={`https://${url}`} utm_medium="leaderboard">
      <img alt={alt} className={styles.ad} src={src} />
    </OutboundLink>
  );
};

export default Ad;
